<h2 mat-dialog-title>Conferma della data</h2>

    <mat-dialog-content>
      <p>Stai per inviare il documento con data {{ formattedDate }}, superiore a 12 giorni fa.</p>
      <p class="mt-2">Confermi?</p>
      <mat-checkbox [(ngModel)]="confirmed">Sì, la data è corretta.</mat-checkbox>
      <!-- if invoice is healthcare -->
      <p class="mt-3">Nota: Questo documento contiene una data incompatibile con l'emissione di Fattura elettronica. Pertanto, il documento può essere generato solo come fattura cartacea e non verrà inviato allo SDI.</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Torna indietro e modifica</button>
      <button mat-raised-button color="primary" [disabled]="!confirmed" (click)="confirm()">
        <mat-icon>check</mat-icon>
        Confermo
      </button>
    </mat-dialog-actions>
